import $ from 'jquery';
import _ from 'lodash';
import get from 'lodash/get';
import Immutable from 'immutable';
import requestFrame from 'request-frame'; // requestAnimationFrame polyfill
import cx from '../../utils/cx.js';
import React from 'react';
import ReactDOM from 'react-dom';
import Constants from '../../constants/Constants';
import ConversationActionCreators from '../../actions/ConversationActionCreators.js';
import ConversationStore from '../../stores/ConversationStore';
import MembersActionCreators from '../../actions/MembersActionCreators.js';
import MessageStore from '../../stores/MessageStore';
import MemberStore from '../../stores/MemberStore';
import FlashMessageStore from '../../stores/FlashMessageStore';
import MessageItem from './MessageItem.react';
import MessagesSectionHeader from './MessagesSectionHeader.react';
import MessageComposer from './MessageComposer.react';
import Linkify from '../misc/Linkify.react.js';
import Emojify from '../misc/Emojify.react.js';
import popup from '../../../app/popup.js';
import modal from '../../../app/modal.js';
import ImageSvg from '../images/ImageSvg.react';
import responsiveness from '../../../../../../sass/foundation/variables/responsiveness.scss';

const Params = Constants.Params;
let currentID = null; // aktīvās sarakstes ID
let firstMessageCreated = null; // pirmā sarakstā (pēc izveides laika vecākā) izveides laiks
let lastMessageCreated = null; // jaunākās vēstules (pēdējā sarakstā) izveides laiks
let loadMoreClick = false; // vai ir nospiesta poga, lai ielādētu vairāk vēstules
let scrollTo = 'bottom'; // null, top, bottom
// var lastScrollSize = 0;
const mainHeader = $('#header');
const subNavTarget = '#subNav';
const mainTopBar = $('#topBar'); // Augšējā paziņojuma josla - admin un unverified lietotājiem
const body = $('body');
let reconnectWS = null;

const request = requestFrame('request'); // requestAnimationFrame polyfill
import Scrollbars from './../misc/Scrollbars.react.js';

function getStateFromStores() {
  const currentIDTmp = ConversationStore.getCurrentID();
  // mainot sarakstes, atjauno vērtības
  if (currentID != currentIDTmp) {
    currentID = currentIDTmp;
    firstMessageCreated = null;
    lastMessageCreated = null;
    loadMoreClick = false;
  }
  const messages = MessageStore.getMessages(currentID);

  let messagesTotal = 0;

  if (messages) {
    messagesTotal = messages.count();
  }

  const lastMessage = MessageStore.getLastMessage(currentID);
  const firstMessage = MessageStore.getFirstMessage(currentID);

  // ja ienāk jauna vēstule, tad scroll uz leju
  if (lastMessage) {
    if (!lastMessageCreated || lastMessage.get('created') > lastMessageCreated) {
      scrollTo = 'bottom';
    }
    lastMessageCreated = lastMessage.get('created');
  } else {
    lastMessageCreated = null;
  }

  // izpildās load more gadījumā un atverot saraksti
  if (firstMessage) {
    if (!firstMessageCreated || firstMessage.get('created') < firstMessageCreated) {
      // atvērtās sarakstes gadījumā, sākotnēji ielasītas dažas vēstules un atverot papildina ar vecākām
      if (!loadMoreClick) {
        scrollTo = 'bottom';
      }
      // load more poga nospiesta
      else {
        loadMoreClick = false;
        // padod pirmās (vecākās) vēstules html div id vērtību
        scrollTo = `#msg-${firstMessageCreated}`;
      }
    }

    firstMessageCreated = firstMessage.get('created');
  } else {
    firstMessageCreated = null;
  }

  return {
    messages,
    messagesTotal,
    firstMessage: MessageStore.getFirstMessage(currentID),
    // sarakstei pirmās ielādes vēstuļu skaits
    openConversationCount: MessageStore.getOpenConversationCount(currentID),
    // cik vēstules ielasītas pie load more
    loadMoreCount: MessageStore.getLoadMoreCount(currentID),
    // vai ir nospiesta load more poga
    loadMoreActive: MessageStore.getLoadMore(),
    createMessage: MessageStore.getCreateMessage(),
    currentConversationID: currentID,
    conversationsTotal: ConversationStore.getTotal(),
    member: MemberStore.get(currentID),
    // TODO
    // memberCanAccess un memberBlocked aizvākt,
    // kad memberStore pārveidots uz immutable-js
    memberCanAccess: MemberStore.getCanAccess(currentID),
    memberBlocked: MemberStore.getBlocked(currentID),
    myProfile: MemberStore.getMyProfile(),
    limitedMessages: MemberStore.getLimitedMessages(),
    hasPaid: MemberStore.getHasPaid(),
    overConversationLimit: MemberStore.getOverConversationLimit(),
    submitOnEnter: MemberStore.getSubmitOnEnter(),
    characterLimit: MemberStore.getCharacterLimit(),
  };
}

class MessagesSection extends React.PureComponent {
  static displayName = 'MessagesSection';

  static defaultProps = {
    hideHeader: false,
    disableAutoHeight: false, // atslēdz augstumu, pielāgojas ekrānam
    dynamicHeight: false, // pielāgojas vēstuļu skaitam
    maxHeight: null,
    disableUserLink: false, // nerādīt link uz lietotāja profilu
    activeMask: false,
    mobile: false,
  };

  constructor(props) {
    super(props);
    const store = getStateFromStores();
    // pievieno scrollHeight, kuru vajag tikai pie init pievienot
    store.scrollHeight = 0;

    this.handleScrollTo = this.handleScrollTo.bind(this);

    scrollTo = 'bottom';
    // aizture teksta atjaunošanai
    this._onMessageChange = _.debounce(this._onMessageChange, 500);

    this.state = {
      data: Immutable.Map(store),
      preserveInput: false,
      lazyLoad: false,
      containerRect: [],
      lazyImgs: [],
      inputHistory: {},
    };
  }

  setImmState = fn => this.setState((prevState) => {
    const data = prevState.data;
    return {
      data: fn(data),
    };
  });

  handleScrollTo = (scrollTo) => {
    let ref = _.get(this.refs, 'messageScroll', false);
    if (!ref) {
      return;
    }
    ref = ref.getInstance();

    if (scrollTo == 'bottom') {
      ref.scrollToBottom();
    } else if (scrollTo == 'top') {
      ref.scrollToTop();
    } else if (scrollTo) {
      const el = document.querySelector(scrollTo);
      if (el && el.scrollTop) {
        ref.scrollTop(el.scrollTop);
      }
    }
  };

  // http://stackoverflow.com/a/28748160
  scrollElement = () => {
    if (!scrollTo) {
      return false;
    }

    // store a this ref, and
    const _this = this;
    // wait for a paint to do scrolly stuff
    request(() => {
      // ja scrollTo nav 'bottom' vai 'top', tad nozīmē, ka padod html id vērtība
      // izmanto load more gadījumos
      let scrollToTmp = null;
      if (scrollTo && scrollTo != 'bottom' && scrollTo != 'top') {
        // skata iepriekšējo elementu, lai varētu līdz tam noskrollēt
        scrollToTmp = $(scrollTo).prev();

        if (!scrollToTmp.length) {
          scrollTo = null;
        } else {
          scrollTo = scrollToTmp.scrollTop();
        }
      }

      _this.handleScrollTo(scrollTo);

      if (!_this.props.dynamicHeight) {
        scrollTo = null;
      }
    });
  };

  // vēstuļu skrollējamās daļas augstums, pielāgoja lapas augstumam
  setScrollHeight = () => {
    if (this.props.disableAutoHeight) {
      return false;
    }

    const data = this.state.data;

    const header = ReactDOM.findDOMNode(this.refs.header);
    const deletedInfo = ReactDOM.findDOMNode(this.refs.deletedInfo);
    const composer = ReactDOM.findDOMNode(this.refs.composer);
    const composerInfo = ReactDOM.findDOMNode(this.refs.composerInfo);
    const windowHeight = $(window).height();

    let scrollHeight = windowHeight - mainHeader.height() - parseInt(body.css('margin-bottom'));
    if (mainTopBar.length) {
      scrollHeight -= mainTopBar.outerHeight();
    }

    if (header) {
      scrollHeight -= header.offsetHeight;
    }

    if (deletedInfo) {
      scrollHeight -= deletedInfo.offsetHeight;
    }

    if (composer) {
      scrollHeight -= composer.offsetHeight;
    }

    if (composerInfo) {
      scrollHeight -= composerInfo.offsetHeight;
    }

    if (scrollHeight < 130) {
      scrollHeight = 130;
    }

    if (data.get('scrollHeight') != scrollHeight) {
      this.setImmState(data => data.update('scrollHeight', item => scrollHeight));
    }
  };

  // pielāgojas vēstuļu skaita augstumam
  setDynamicHeight = () => {
    const data = this.state.data;
    const self = this;

    const node = ReactDOM.findDOMNode(this);
    this.setState({
      containerRect: node.getBoundingClientRect(),
    });
    this.setState({
      lazyImgs: node.querySelectorAll('img[data-src]'),
    });

    /* if (!this.props.dynamicHeight || this.props.maxHeight <= data.get('scrollHeight')) {
      return;
    } */

    if (!this.props.dynamicHeight) {
      return;
    }

    //
    let { maxHeight } = this.props;
    if (!maxHeight) {
      const header = ReactDOM.findDOMNode(this.refs.header);
      const deletedInfo = ReactDOM.findDOMNode(this.refs.deletedInfo);
      const composer = ReactDOM.findDOMNode(this.refs.composer);
      const composerInfo = ReactDOM.findDOMNode(this.refs.composerInfo);
      const windowHeight = $(window).height();

      maxHeight = windowHeight - mainHeader.height() - parseInt(body.css('margin-bottom'));
      if (mainTopBar.length) {
        maxHeight -= mainTopBar.outerHeight();
      }

      if (header) {
        maxHeight -= header.offsetHeight;
      }

      if (deletedInfo) {
        maxHeight -= deletedInfo.offsetHeight;
      }

      if (composer) {
        maxHeight -= composer.offsetHeight;
      }

      if (composerInfo) {
        maxHeight -= composerInfo.offsetHeight;
      }

      if (maxHeight < 130) {
        maxHeight = 130;
      }
    }

    if (data.get('messagesTotal') == 0) {
      if (data.get('currentConversationID')) {
        const conversationEmpty = ReactDOM.findDOMNode(this.refs.conversationEmpty);
        if (conversationEmpty) {
          this.setImmState(data => data.update('scrollHeight', item => conversationEmpty.offsetHeight));
          return;
        }
      }

      if (data.get('scrollHeight') > 0) {
        this.setImmState(data => data.update('scrollHeight', item => maxHeight));
      }
      return;
    }

    // nano-content augstums
    const height = this.getContentHeight();

    if (height >= maxHeight) {
      this.setImmState(data => data.update('scrollHeight', item => maxHeight));
      return;
    }

    /* if (height != data.get('scrollHeight')) {
      // this.setState({scrollHeight: height});
      this.setImmState(data => data.update('scrollHeight', item => height));
    } */

    this.setImmState(data => data.update('scrollHeight', item => height));
  };

  // atgriež augstumu, cik daudz px aizņem visi messageItem iekš .nano-content
  getContentHeight = () => {
    const node = ReactDOM.findDOMNode(this);
    const items = $(node).find('.messageItem');
    let height = 0;

    $.each(items, function () {
      height += ($(this).outerHeight() + 1);
    });

    return height;
  };

  // TODO If want to use websockets to show messages before they are actually sent..
  // Need to figure out something with errors.
  // How to show errors if there are any (for example too many equal messages sent today) during actual sending process.
  // And.. then remove message which is already shown? Show for a moment and then remove if it's not actually sent?
  // But that would be so strange.
  // So probably can't show message before it's actually sent, because can't know if it's a valid message (for example, not blacklisted), and actually sent.
  openWebSocket = () => {
    return;
    /* const _this = this;

    const currentMemberId = _.get(globals, 'currentMember.id', null);
    if (!currentMemberId) {
      return;
    }

    const webSocketHost = _.get(globals, 'webSocketHost', null);
    if (!webSocketHost) {
      return;
    }

    //
    //const webSocket = new WebSocket(`ws://${webSocketHost}:2443?id=${currentMemberId}`);
    const webSocket = new WebSocket(`wss://${webSocketHost}:2443?id=${currentMemberId}`);

    // Open
    webSocket.onopen = () => {
      MessageStore.setWebSocket(webSocket);
    };

    // Message
    webSocket.onmessage = (e) => {
      if (!e.data || !_.isString(e.data)) {
        return;
      }

      //
      const data = JSON.parse(e.data);
      if (!data.hasOwnProperty('from') || !data.hasOwnProperty('to') || !data.hasOwnProperty('action')) {
        return;
      }

      // New message
      if (data.action === 'send') {
        if (currentMemberId === data.to) {
          this.updateFromWebSocketSend(data, data.from, currentMemberId);
        } else {
          this.updateFromWebSocketSend(data, data.to);
        }
      }

      // New 'read' mark
      if (data.action === 'read') {
        this.updateFromWebSocketRead(currentMemberId, data);
      }
    }

    // Error
    webSocket.onerror = (event) => {
      MessageStore.setWebSocket(null);
      console.error('WebSocket error observed:', event);
    };

    // Close
    webSocket.onclose = function(event) {
      MessageStore.setWebSocket(null);
      reconnectWS = setTimeout(function() {
        _this.openWebSocket();
      }, 1000);
    }; */
  };

  // TODO If want to use websockets to show messages before they are actually sent..
  // Need to figure out something with errors.
  // How to show errors if there are any (for example too many equal messages sent today) during actual sending process.
  // And.. then remove message which is already shown? Show for a moment and then remove if it's not actually sent?
  // But that would be so strange.
  // So probably can't show message before it's actually sent, because can't know if it's a valid message (for example, not blacklisted), and actually sent.
  updateFromWebSocketSend = (data, updatedId, currentMemberId = null) => {
    return;
    /* const currentId = ConversationStore.getCurrentID();

    // Conversation not open, update conversations
    if (!currentId || currentId !== updatedId) {
      const firstConversation = ConversationStore.getFirst();
      let updated = firstConversation ? firstConversation.get('updated') : null;
      //
      ConversationActionCreators.conversationsLoad(updated, 'greater', true, false, false, true);
      return;
    } */

    // Conversation open, update messages
    /*
    const newestMessage = MessageStore.getLastMessage(updatedId);
    if (newestMessage) {
      ConversationActionCreators.updateMessages(updatedId, newestMessage.get('created'), currentMemberId);
    }
    */

    // update messages pirms saglabāts DB
    // ConversationActionCreators.updateMessagesFromWebsockets(data, updatedId);
  }

  // TODO If want to use websockets to show messages before they are actually sent..
  // Need to figure out something with errors.
  // How to show errors if there are any (for example too many equal messages sent today) during actual sending process.
  // And.. then remove message which is already shown? Show for a moment and then remove if it's not actually sent?
  // But that would be so strange.
  // So probably can't show message before it's actually sent, because can't know if it's a valid message (for example, not blacklisted), and actually sent.
  updateFromWebSocketRead = (currentMemberId, data) => {
    return;
    /* if (MessageStore.getConversationsLoading()) {
      setTimeout(() => {
        this.updateFromWebSocketRead(currentMemberId, data);
      }, 1000);
      return;
    }

    if (currentMemberId === data.from) {
      MessageStore.updateMessagesAsRead(data.to, data.timestamp || (Math.floor(Date.now() / 1000) * 1000));
      MessageStore.setSentMessagesUpdate(data.to);
      MessageStore.emitChange();

      ConversationStore.updateConversationLastMessage(data.to);
      ConversationStore.emitChange();
      return;
    }

    ConversationStore.setRead(data.from);

    const openId = ConversationStore.getCurrentID();
    if (!openId || openId !== data.from) {
      const unreadCount = ConversationStore.getUnread();
      if (unreadCount) {
        ConversationStore.setUnread(unreadCount - 1);
      }
    }

    ConversationStore.emitChange(); */
  }

  // TODO If want to use websockets to show messages before they are actually sent..
  // Need to figure out something with errors.
  // How to show errors if there are any (for example too many equal messages sent today) during actual sending process.
  // And.. then remove message which is already shown? Show for a moment and then remove if it's not actually sent?
  // But that would be so strange.
  // So probably can't show message before it's actually sent, because can't know if it's a valid message (for example, not blacklisted), and actually sent.
  closeWebSocket = () => {
    return;
    /* const webSocket = MessageStore.getWebSocket();
    if (webSocket) {
      webSocket.close();
    } */
  }

  showReportStatus(status, message) {
    const text = status === 'success' ? 'txt: Paldies, ziņojums pieņemts!' : 'txt: Neizdevās reportēt komentāru';

    let options = {};
    const created = message.get('created');
    const $message = $(`#msg-${message.get('created')}`);
    if ($message.length) {
      let top = $message.offset().top - mainHeader.height() + $message.outerHeight(true);

      if (mainTopBar.length) {
        top -= mainTopBar.outerHeight();
      }

      // 'hideHeader' should be 'true' only in 'PrivateMessagesApp' (messages in user profile view)
      if (this.props.hideHeader) {
        const $subNav = $(subNavTarget);

        if ($subNav.length) {
          top -= $subNav.height();
        }
      }

      options = {
        style: {
          width: $message.outerWidth(true),
          top,
          left: 'auto',
          right: 0,
        }
      }
    }

    FlashMessageStore.removeAll();
    FlashMessageStore.add(`${String(Date.now())}_${ message.get('_id')}`, status, get(translations, text, text), options);
    FlashMessageStore.emitChange();

    MessageStore.updateReportStatus(message, null);
  }

  showLoadFailMessage(message) {
    const options = { style: { top: 0 } };
    const $messageComposer = $('.messageComposer');
    if ($messageComposer.length) {
      options.style.top = $messageComposer.position().top;

      if ($(window).width() > responsiveness.breakpoint) {
        options.style.width = $messageComposer.outerWidth();
        options.style.left = 'auto';
      }
    }

    FlashMessageStore.removeAll();
    FlashMessageStore.add(`${String(Date.now())}_${message}`, 'notice', message, options);
    FlashMessageStore.emitChange();

    MessageStore.setLoadFailMessage(null);
  }

  componentDidMount() {
    window.addEventListener('resize', this._onResize);

    ConversationStore.addChangeListener(this._onChange);
    MessageStore.addChangeListener(this._onChange);
    MemberStore.addChangeListener(this._onChange);

    const _this = this;
    $(document).ready(() => {
      /* var $nano = $('.nano-content');
      $nano.on('scroll', _this._onNanoScroll); */


      _this.setScrollHeight();
      _this.setDynamicHeight();
      _this.scrollElement();
      // _this.openWebSocket();
      _this._lazyLoad(null, 'nano-content');
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._onResize);

    ConversationStore.removeChangeListener(this._onChange);
    MessageStore.removeChangeListener(this._onChange);
    MemberStore.removeChangeListener(this._onChange);

    // this.closeWebSocket();
    clearTimeout(reconnectWS);
  }

  componentDidUpdate(prevProps, prevState) {
    // uzspiests uz sarakstes, ielādē vēstules
    const currentConversationIDOld = prevState.data.get('currentConversationID');
    const currentConversationIDNew = this.state.data.get('currentConversationID');

    const messagesTotalOld = prevState.data.get('messagesTotal');
    const messagesTotalNew = this.state.data.get('messagesTotal');


    if (
      (currentConversationIDOld !== currentConversationIDNew) ||
      (messagesTotalOld !== messagesTotalNew)
    ) {
      this.setScrollHeight();
      this.setDynamicHeight();
      this.scrollElement();
      this._lazyLoad(null, 'nano-content', true);
    }

    const messages = this.state.data.get('messages');
    if (messages) {
      messages.map((message) => {
        const reportStatus = message.get('report_status');
        if (reportStatus) {
          this.showReportStatus(reportStatus, message);
        }
      });
    }

    const loadFailMessage = MessageStore.getLoadFailMessage();
    if (loadFailMessage) {
      this.showLoadFailMessage(loadFailMessage);
    }
  }

  render() {
    const self = this;
    const data = this.state.data;

    // ja tukša sarakste
    let MessageItems = Immutable.List();

    const myProfile = data.get('myProfile');
    const member = data.get('member');
    const messagesTotal = data.get('messagesTotal');
    const openConversationCount = data.get('openConversationCount');
    const loadMoreCount = data.get('loadMoreCount');
    const loadMoreActive = data.get('loadMoreActive');
    let composerArrow = false; // vai rādīt bultiņu (izvirzījumu) uz augšu
    const conversationsTotal = data.get('conversationsTotal');
    const currentConversationID = data.get('currentConversationID');

    const divStyle = {
      height: 0,
    };

    const Header = function () {
      if (self.props.hideHeader || !member) {
        return null;
      }

      let disableVideo = true;
      let hideVideo = true;
      let disablePDF = false;
      let videoTooltip;
      if (
        (typeof util !== 'undefined' && util.supports.audioVideo) &&
        member.videochat &&
        member.online &&
        !data.get('limitedMessages')
      ) {
        disableVideo = false;
      }
      if (disableVideo) {
        if (data.get('limitedMessages')) {
          videoTooltip = get(translations, 'txt: Lai izmēģinātu videočatu jāiegādājas abonements.', '');
        } else if (member.online !== true) {
          videoTooltip = get(translations, 'txt: Šis lietotājs pašlaik nav tiešsaistē.', '');
          videoTooltip = videoTooltip.replace('{:name}', member.name);
        } else if (member.videochat !== true) {
          videoTooltip = get(translations, 'txt: {:name} pārlūks neatbalsta videočatu, lai izmēģinātu videočatu, jums abiem jāizmanto Google Chrome.', '');
          videoTooltip = videoTooltip.replace('{:name}', member.name);
        } else {
          videoTooltip = get(translations, 'txt: Tavs pārlūks neatbalsta videočatu, lai izmēģinātu videočatu, jums abiem jāizmanto Google Chrome.', '');
        }
      }

      if (
        (window.location.href.indexOf('/messages') !== -1) &&
        get(globals, 'videochatEnabled', false)
      ) {
        hideVideo = false;
      }

      if (!myProfile.has_paid) {
        disablePDF = true;
      }

      const totalUnread = ConversationStore.getUnread() || '';

      return (
        <div ref="header">
          <MessagesSectionHeader
            disableVideo={disableVideo}
            videoTooltip={videoTooltip}
            hideVideo={hideVideo}
            disablePDF={disablePDF}
            member={member}
            totalUnread={totalUnread}
          />
        </div>
      );
    };

    const ComposerBlock = function () {
      if (!member) {
        return null;
      }

      // ja ir sūtītājs ir admin, izvada linku uz saziņas formu
      if (member.status == 'admin') {
        const suggestions_link = `${get(globals, 'webroot', '/')}suggestions/index`;
        return (
          <div className="messageComposerInfo tar" ref="composerInfo">
            <a href={suggestions_link} className="btn btn--a btn--small">
              {get(translations, 'txt: Sazināties ar administratoru', '')}
            </a>
          </div>
        );
      }

      // admin var visiem sūtīt vēstules
      // ja ir parastais lietotājs, tad var sūtīt vēstuli tikai active lietotājiem
      if (!myProfile || (!member.can_access)) {
        let cannotReplyText = get(translations, 'txt: Ar šo lietoāju Tu diemžēl nevari sazināties.', '');
        // Ja bloķēts, rāda paskaidrojumu
        if (member.blocked) {
          cannotReplyText += ` ${get(translations, 'txt: Jūs esat bloķējis šo lietotāju!', '')}`;
        }
        return (
          <div className="messageComposerInfo" ref="composerInfo">
            {cannotReplyText}
          </div>
        );
      }
      if (self.props.activeMask) {
        const maskoffLink = `${get(globals, 'webroot', '')}/members/disable_mask`;
        return (
          <div className="messageComposerInfo tac" ref="composerInfo">
            {get(translations, 'txt: Lai sazinātos, noņem masku un kļūsti redzams. :)', '')} <br />
            <a className="btn btn--b btn--small" href={maskoffLink}>{get(translations, 'txt: Uz brīdi noņemt masku', '')}</a>
          </div>
        );
      }

      // ievades lauka teksts
      let initialMessage = '';
      let initialMessageAfterSubmit = '';
      if (myProfile.status === 'admin' && member.admin.use_signature) {
        initialMessage = '\r\n\r\n' + member.admin.use_signature;
        initialMessageAfterSubmit = '\r\n\r\n' + member.admin.use_signature;
      }
      const { inputHistory } = self.state;
      if (inputHistory[currentConversationID]) {
        initialMessage = inputHistory[currentConversationID];
      }
      // overConversationLimit ir cipars pa cik ir pāri limitam. Ja ir 0, nozīmē ir sasniegts limits un nevajadzētu ļaut sūtīt vēstuli
      let overConversationLimit = true;
      if (data.get('overConversationLimit') === false) {
        overConversationLimit = false;
      }

      return (
        <div ref="composer">

          {
            !member.subscription && (
              <div className="tac pas tcrg" key="conversation_empty" ref="conversationEmpty" style={{borderTop: '1px solid #f2f2f2'}}>
                <ImageSvg svg="icon-warning" iconClass="icon--grey icon--warning-2" />
                <span className='mls'>Šim lietotājam nav abonementa. Viņš uz Tavu ziņu varēs atbildēt, kad būs to iegādājies.</span>
              </div>
            )
          }

          <MessageComposer
            preserveInput={self.state.preserveInput}
            key={currentConversationID + self.props.id}
            id={currentConversationID + self.props.id}
            memberId={currentConversationID}
            disabled={data.get('createMessage')}
            senderId={myProfile._id}
            showArrow={composerArrow}
            showSubscription={data.get('limitedMessages')}
            showOverConversationLimit={overConversationLimit}
            showVerification={myProfile.status == 'unverified'}
            onMessageSubmit={self._onMessageSubmit}
            onMessageChange={self._onMessageChange}
            onChangeEnter={self._onChangeEnter}
            initialMessage={initialMessage}
            initialMessageAfterSubmit={initialMessageAfterSubmit}
            submitOnEnter={data.get('submitOnEnter')}
            characterLimit={data.get('characterLimit')}
          />
        </div>
      );
    };


    // jāizvēlas sarakste
    if (conversationsTotal > 0 && _.isEmpty(currentConversationID)) {
      MessageItems = MessageItems.push(<div className="tac pam" key="conversation_select">{get(translations, 'txt: Izvēlies saraksti', '')}</div>);
    }

    // tukša sarakste
    else if (!_.isEmpty(currentConversationID) && messagesTotal < 1) {
      // nav abo - nevarēs atbildēt
      MessageItems = MessageItems.push(<div className="tac pam" key="conversation_empty" ref="conversationEmpty">{get(translations, 'txt: Sarakstes vēsture ir tukša', '')}</div>);
    }


    // ir vēstules
    // ja ir atvērts lietotāja skats, tad tajā sarakstē Total ir 0 un tāpēc ir pārbaufe vai nav tukšs ID
    else if (conversationsTotal > 0 || !_.isEmpty(currentConversationID)) {
      let loadMore = true;

      // vai rādīt load more pogu
      if (
        (openConversationCount !== false && openConversationCount < Params.messagesPage)
        ||
        (loadMoreCount !== false && loadMoreCount < Params.messagesPage)
      ) {
        loadMore = false;
      }

      MessageItems = data.get('messages').map(function (message) {
        let indent = false; // savam ierakstam atkāpe
        let profile = {};
        const onClickDelete = this._onClickDelete.bind(this, message);
        const onClickReport = this._onClickReport.bind(this, message);
        const onClickShowHidden = this._onClickShowHidden.bind(this, message);
        let disableUserLink = false; // Lai vēstulē nav link uz profilu
        let unread = false; // nav izlasīta vēstule
        let showReadIcon = false; // rādīt 'izlasīts' ikonu
        let showReadIconUnpaid = !data.get('hasPaid');
        let showReport = false; // rādīt 'ziņot' ikonu
        let showUncensored = false;
        const reported = message.get('reported');
        const hidden = message.get('hidden');

        // nerādīt linkus uz profiliem
        if (self.props.disableUserLink) {
          disableUserLink = true;
        }

        // mans profils
        if (myProfile && myProfile._id == message.sender_id) {
          profile = myProfile;
          indent = true;
          disableUserLink = true;
          showUncensored = true;
          if (!showReadIconUnpaid) {
            showReadIcon = true; // izsūtītām vēstulēm rāda, vai ir izlasīts
            // pazīme, ka nav izlasīta
            if (!message.get('read')) {
              unread = true;
            }
          }
        } else if (showReadIconUnpaid) {
          showReadIconUnpaid = false;
        }

        // otra profils
        if (message.get('member_id') == message.get('sender_id')) {
          profile = member;
          showReport = true;
        }

        // teksta transformācijas

        const newString = function (stringItem) {
          if (stringItem == '') {
            return (<span><br /></span>);
          }

          return (
            <Linkify
              thumbSize="l"
              openGallery
              messageId={message.get('_id')}
              showUncensored={showUncensored}
            >
              <Emojify>
                {stringItem}
              </Emojify>
            </Linkify>
          );
        };

        // sadala tekstu pa rindiņām
        // katrai rindiņai ievieto smaidiņu
        // katras rindiņas beigās <br>

        const finalText = _.map(message.get('text').split('\n'), (stringItem, i) => (
          <div key={i}>
            {newString(stringItem)}
          </div>
        ));

        return (
          <div key={message.get('_id')} id={`msg-${message.get('created')}`}>
            <MessageItem
              memberId={profile._id}
              verified={profile.verified}
              text={finalText}
              date={message.get('created')}
              large
              disableHover
              showReadIconUnpaid={showReadIconUnpaid}
              indent={indent}
              unread={unread}
              deleted={message.get('deleted')}
              showReadIcon={showReadIcon}
              imageType="xs"
              disableUserLink={disableUserLink}
              onClickDelete={onClickDelete}
              onClickReport={onClickReport}
              showReport={showReport}
              reported={reported}
              hidden={hidden}
              showHiddenText={get(translations, 'txt: Rādīt', 'txt: Rādīt')}
              onClickShowHidden={onClickShowHidden}
              mobile={self.props.mobile}
              setDynamicHeight={self.props.dynamicHeight ? self.setDynamicHeight : null}
            />
            <div className="messages-line messages-line--large" />
          </div>
        );
      }, this);

      if (loadMore) {
        const loadMoreButton = function () {
          return (
            <div className="tac pas" key={currentConversationID}>
              <a
                className={cx([
                  'btn btn--small btn--c',
                  ['has-loader', loadMoreActive],
                ])}
                onClick={self._onClickLoadMore}
              >
                {get(translations, 'txt: Ielādēt vairāk', '')}
              </a>
            </div>
          );
        };
        // pievieno sākumā
        MessageItems = MessageItems.unshift(loadMoreButton());
      }

      composerArrow = true;
    }

    /* divStyle.height = data.get('scrollHeight'); */

    // this.scrollElement();

    const DeletedInfo = function () {
      if (!member || !member.deleted) {
        return null;
      }

      return (
        <div
          ref="deletedInfo"
          className="messages-main-deleted"
        >
          <div
            className="mbxs"
            dangerouslySetInnerHTML={{__html: get(translations, 'txt: Šis lietotājs ir dzēsis savu profilu, un šī sarakste drīz tiks automātiski dzēsta', '')}}
          />
          <a
            className="btn btn--delete btn--iconLeft btn--small mts mbxs"
            onClick={self._onDeleteConversation.bind(self, member._id)}
          >
            {get(translations, 'txt: Dzēst tagad', '')}
            <span className="btn-static">
              <ImageSvg svg="icon-trash" iconClass="icon--center icon--trash" />
            </span>
          </a>
        </div>
      );
    }

    return (
      <div>
        {Header()}
        {DeletedInfo()}
        <Scrollbars
          ref="messageScroll"
          autoHeight
          autoHeightMax={this.props.maxHeight || data.get('scrollHeight')}
        >
          <div className="nano-content" onScroll={this._lazyLoad}>
            {MessageItems.toArray()}
          </div>
        </Scrollbars>
        {ComposerBlock()}
      </div>
    );
  }

  _lazyLoad = (e, target, update) => {
    const containerRect = this.state.containerRect;
    const lazyImgs = this.state.lazyImgs;
    var update = false;

    for (let i = 0; i < lazyImgs.length; i++) {
      const coords = lazyImgs[i].getBoundingClientRect();

      if (
        (coords.top >= containerRect.top && coords.top <= containerRect.bottom) // Top is visible
        || (coords.bottom >= containerRect.top && coords.bottom <= containerRect.bottom) // Bottom is visible
        || (coords.top <= containerRect.top && coords.bottom >= containerRect.bottom) // Center is visible
      ) {
        lazyImgs[i].src = lazyImgs[i].getAttribute('data-src');
        lazyImgs[i].removeAttribute('data-src');
        update = true;
      }
    }

    if (update) {
      let newLazyImgs = [];
      if (!target) {
        newLazyImgs = e.target.querySelectorAll('img[data-src]');
      } else {
        const n = document.getElementsByClassName(target);
        newLazyImgs = n[0].querySelectorAll('img[data-src]');
      }
      this.setState({
        lazyImgs: newLazyImgs,
      });
    }
  };

  /**
   * Event handler for 'change' events coming from the stores
   */
  _onChange = () => {
    this.setImmState((data) => {
      const stateData = getStateFromStores();
      // pārveido par immutable MAP, lai būtu korekts merge
      const stateDataImm = Immutable.Map(stateData);
      return data.merge(stateDataImm);
    });
  };

  /**
   * Event handler for 'onClick' - load more
   */
  _onClickLoadMore = (e) => {
    e.preventDefault();
    const data = this.state.data;
    // info logs, ja nav abo

    if (data.get('limitedMessages') && _.get(globals, 'currentMember.status', '') !== 'simulated') {
      popup.subscriptionMessage();
      return;
    }

    const memberId = data.get('currentConversationID');
    const firstMessage = data.get('firstMessage');

    if (firstMessage) {
      loadMoreClick = true;
      ConversationActionCreators.messagesLoadMoreClick(memberId, firstMessage.get('created'));
    }
  };

  /**
   * Event handler for 'onClick' - delete message
   */
  _onClickDelete = (message) => {
    const data = this.state.data;
    // info logs, ja nav abo
    if (data.get('limitedMessages')) {
      popup.subscriptionMessage();
      return;
    }

    modal.confirm(get(translations, 'txt: Vai tiešām dzēst?', ''), (response) => {
      if (response) {
        ConversationActionCreators.deleteMessage(message);
      }
    });
  };

  /**
   * Event handler for 'onClick' - report message
   */
  _onClickReport = (message) => {
    modal.confirm(get(translations, 'txt: Vai tiešām ziņot par šo vēstuli?', ''), (response) => {
      if (response) {
        ConversationActionCreators.reportMessage(message);
      }
    });
  };

  /**
   * Event handler for 'onClick' - show hidden message
   */
  _onClickShowHidden = (message) => {
    MessageStore.setHidden(message, false);
    MessageStore.emitChange();
  };

  /**
   * Event handler - message submit
   */
  _onMessageSubmit = (message, preserveHistory, ignoreCharacterLimit) => {
    const data = this.state.data.toJS();
    const currentConversationID = data.currentConversationID;
    // padod datus par jauno vēstuli
    ConversationActionCreators.createMessage(message, currentConversationID, ignoreCharacterLimit);
    //
    const { inputHistory } = this.state;
    // pie submit iztukšo
    if (!preserveHistory) {
      inputHistory[currentConversationID] = '';
      this.setState({
        inputHistory,
        preserveInput: false,
      });
    } else {
      if (data.myProfile.status === 'admin' && data.member.admin.use_signature) {
        inputHistory[currentConversationID] = '\r\n\r\n' + data.member.admin.use_signature;
      }
      this.setState({
        inputHistory: inputHistory,
        preserveInput: true
      });
    }
    scrollTo = 'bottom';
  };

  /**
   * Event handler - message change
   */
  _onMessageChange = (message) => {
    const data = this.state.data;
    const currentConversationID = data.get('currentConversationID');
    const inputHistory = this.state.inputHistory;
    if (data.get('createMessage')) {
      inputHistory[currentConversationID] = '';
      this.setState({ inputHistory });
      return;
    }
    inputHistory[currentConversationID] = message;
    this.setState({ inputHistory });
  };

  /**
   * Event handler for 'resize'
   */
  _onResize = () => {
    const _this = this;
    $(document).ready(() => {
      _this.setScrollHeight();
      _this.scrollElement();
      if ($('body').hasClass('d-mailee')) {
        return;
      }
      _this.setDynamicHeight();
    });
  };

  /**
   * Event handler - on change enter checkbox
   */
  _onChangeEnter = (checked) => {
    MembersActionCreators.submitOnEnter(checked);
  };

  /**
   * Event handler - on delete conversation
   */
  _onDeleteConversation = (conversationId) => {
    modal.confirm(_.get(translations, 'txt: Vai tiešām dzēst?'),  (response) => {
      if (response) {
        ConversationActionCreators.deleteConversation(conversationId);
      }
    });
  };

  /* shouldComponentUpdate(nextProps, nextState) {
    return React.addons.shallowCompare(this, nextProps, nextState);
  } */
}

module.exports = MessagesSection;
